import React from "react";
import { Box, Typography } from "@mui/material";
import { withAuth } from "../../hoc";
import LeadsList from "./LeadsList";

const Leads = (): JSX.Element => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: { xs: 2, md: 3 },
        height: "100%",
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
          flexShrink: 0,
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          Leads
        </Typography>
      </Box>
      <LeadsList />
    </Box>
  );
};

export default withAuth(Leads);
